import RFMarquee from 'react-fast-marquee'
import styles from './styles.module.scss'
import clsx from 'clsx'

const Item = () => {
  return (
    <div className="flex items-center gap-9 pr-9 my-2 py-3 border-y-2 border-y-white">
      <p>Join us at the 2023 Technology & Innovation Summit - September 2023</p>
      <div className="w-2 h-2 bg-white rounded-full" />
      {/* <p>View Details</p> */}
      {/* <div className="w-2 h-2 bg-white rounded-full" /> */}
    </div>
  )
}

export function Marquee() {
  return (
    <RFMarquee
      className={clsx(
        styles.marquee,
        'text-white font-semibold bg-mx-purple-neon',
      )}
      pauseOnHover>
      <Item />
      <Item />
      <Item />
    </RFMarquee>
  )
}
